/**
* author: duxin
* date: 2020/4/7
* describe: 关于我们块
*/

<template>
	<div class="chunk-wrap about-me1">
		<!-- <p class="p1">{{$t("home.about")}}</p> -->
		<!-- <h2>{{$t("home.content1")}}</h2>
		<h2>{{$t("home.content11")}}</h2> -->

		<!--<br/>-->
		<!--<p class="p2">{{$t("home.content1")}}</p>-->
		<!-- <div class="content-wrap-1">
            <img class="about-img"
                 src="../../../assets/KR05J7BX6STTQ98C4T8E.jpg">
            <div class="right-1">
                <p style="white-space: pre-wrap">{{$t("home.content2")}}
                    <br/>
                    {{$t("home.content3")}}
                    </p>
                <div class="more-btn-icon">
                    <RouterLink to="/about">
                        <ElButton type="primary" class="more-btn">{{$t("home.seeMore")}}</ElButton>
                        <i class="iconfont iconmore"></i>
                    </RouterLink>
                </div>
            </div>
		</div>-->
		<!-- <div class="content-wrap-2">
			<div v-for="item in goalList">
				<p :class="lang == 'en' ? 'title' : 'title-60'">{{item.title}}</p>
				<br />
				<p class="content">{{item.content}}</p>
			</div>
		</div> -->
		<!-- 企业文化 -->
		<div class="bc-width" id="culture">
			<CultureChunk class="width"></CultureChunk>
		</div>
		<div class="desc-wrap bc-width">
			<div style="display: flex; width: 1200px; margin: 0 auto;">
				<h1 class="p1" style="text-align: left;">
					<span class="title">{{$t("home.content1")}}</span>
				</h1>
				<h4 class="p2"  :class="lang == 'en' ? 'p2-en' : 'p2-zh'">
					{{$t("about.content1")}}
					<br />
					<br />
					{{$t("about.content2")}}
				</h4>
			</div>
		</div>
	</div>
</template>

<script>
import CultureChunk from './culture-chunk.vue'

export default {
	name: 'about-me-chunk',
	components: { CultureChunk, },
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
	data() {
		this.goalList = [
			{
				title: this.$t('home.values'),
				content: this.$t('home.valuesText'),
			},
			{
				title: this.$t('home.mission'),
				content: this.$t('home.missionText'),
			},

			{
				title: this.$t('home.vision'),
				content: this.$t('home.visionText'),
			},
		]
		return {}
	},
}
</script>

<style lang="less" scoped>
@import "../../../style/constant.less";
@import "./chunk";

.about-me1 {
	h2 {
		color: #5f6464;
		text-align: center;
		font-weight: lighter;
	}
	h2:first-child {
		margin: 30px 0;
	}
	// 包裹的div
	.bc-width {
		width: 100%;
		background-color: #fafafa;
	}
}
.chunk-wrap {
	// padding: 100px 0;
	.content-wrap-1 {
		display: flex;
		margin: 60px 0 50px;

		.about-img {
			max-height: 280px;
			width: 470px;
			flex-shrink: 0;
		}

		.right-1 {
			margin-left: 100px;
			color: @content-color;
			font-size: 16px;
			line-height: 30px;
			letter-spacing: 1px;

			.more-btn-icon {
				margin-top: 25px;
				position: relative;

				.more-btn {
					background-color: @primary-color;
					border-color: @primary-color;
				}

				.iconfont {
					position: absolute;
					width: 35px;
					height: 40px;
					left: 96px;
					line-height: 40px;
					color: #fff;
					text-align: center;
					border-top-right-radius: 4px;
					border-bottom-right-radius: 4px;
					background-color: @active-color;
					border-color: @active-color;

					&:hover {
						cursor: pointer;
					}
				}
			}
		}
	}

	.content-wrap-2 {
		display: flex;
		margin-top: 80px;

		div {
			flex: 1;
			height: 200px;
			text-align: center;

			.title {
				margin-top: 30px;
			}

			.title-60 {
				margin-top: 60px;
			}

			&:nth-child(1) {
				background-color: #1e3bc8;
			}

			&:nth-child(2) {
				background-color: #2563e8;
			}

			&:nth-child(3) {
				background-color: #3677ff;
			}
			p {
				color: white;
			}
			.title,
			.title-60 {
				font-size: 26px;
			}
			.content {
				font-size: 15px;
			}
		}
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.content-wrap-1 {
			margin-top: 30px;
			flex-direction: column;
			.about-img {
				width: 100%;
			}
			.right-1 {
				margin-top: 30px;
				margin-left: 0 !important;
			}
		}
		.content-wrap-2 {
			flex-direction: column;
			height: calc(3 * 200px);
			width: 90%;
			margin: 40px auto;
			div {
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;

				.title,
				.title-60 {
					font-size: 18px;
					margin: 0;
				}
				.content {
					padding: 0 40px;
					font-size: 13px;
				}
			}
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.chunk-wrap {
		width: 100%;
		padding: 100px 0 0;
		h2:first-child {
			margin-bottom: 8px;
		}
	}
	.desc-wrap {
		width: 100%;
		padding: 30px 15px 15px 15px;
		flex-direction: column;
		margin: 0 auto;
		.title {
			font-size: 24px;
		}
		img {
			height: 50vh;
		}
		.p1 {
			margin-bottom: 20px;
			&::after {
				content: " ";
				height: 0px;
			}
		}
		.p1,
		.p2 {
			width: 100%;
		}
	}
}
.desc-wrap {
	display: flex;
	color: @content-color;
	width: @page-width;
	margin: 0 auto;
	background: #fbfbfb url("../../../assets/metaBg.png") no-repeat center;

	.title {
		line-height: 1.2em;
		color: @h2-color;
	}
	.p1 {
		position: relative;
		width: 30%;
		padding: 60px 0 60px 0px;
		&::after {
			position: absolute;
			content: " ";
			background-color: #d9d9d9;
			width: 1px;
			top: 60px;
			left: 300px;
			bottom: 60px;
			height: 75%;
		}
	}
	.p2 {
		line-height: 1.5;
		text-indent: 4ch;
		width: 70%;
		letter-spacing: 1px;
		white-space: pre-line;
		padding: 60px 0 30px 0;
	}
	.p2-en {
		text-align: left;
	}
	.p2-zh {
		text-align: justify;
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.p1 {
			padding: 0px;
		}
		.p2 {
			padding: 0px;
		}
	}
}
</style>